import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DisplayBooks from "../components/DisplayBooks";
import DisplayHobbies from "../components/DisplayHobbies";
import DisplayLanguages from "../components/DisplayLanguages";
import DisplayMovies from "../components/DisplayMovies";
import DisplayMusic from "../components/DisplayMusic";
import BigButton from "../components/events/BigButton";
import MatchStatus from "../components/matches/MatchStatus";
import Spinner from "../components/Spinner";
import TopLeftDetails from "../components/TopLeftDetails";
import UserImage from "../components/UserImage";
import UserName from "../components/UserName";
import UserRecentInterest from "../components/UserRecentInterest";
import WhatsAppLink from "../components/UserWhatsApp";
import { auth, getUserData } from "../firebase";
import useMatches from "../hooks/useMatches";

const PublicUserProfile = ({ uid: propUid, onClose }) => {
	const { uid: routeUid } = useParams();
	const uid = propUid ?? routeUid;
	const [userData, setUserData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const currentUid = auth.currentUser?.uid;
	const { iHaveMatchedThem, theyHaveMatchedMe, isMutualWith } = useMatches(currentUid);
	const isMutual = uid ? isMutualWith(uid) : false;

	useEffect(() => {
		const fetchData = async () => {
			try {
				setIsLoading(true);
				const data = await getUserData(uid);
				setUserData(data);
			} catch (error) {
				console.error("Failed to load user data:", error);
			} finally {
				setIsLoading(false);
			}
		};

		if (uid) fetchData();
	}, [uid]);

	if (isLoading) return <Spinner />;
	if (!userData) return <div>User not found.</div>;

	return (
		<div className="container">
			<BigButton
				title="Go Back"
				icon="bi bi-arrow-left-circle"
				onClick={onClose ? onClose : () => window.history.back()}
			/>

			<div className="my-2 d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2">
				<h2 className="mb-0">{userData.displayName || "User"}</h2>

				<MatchStatus
					displayName={userData?.displayName}
					iHaveMatched={iHaveMatchedThem(uid)}
					theyMatched={theyHaveMatchedMe(uid)}
					isMutual={isMutualWith(uid)}
					isCurrentUser={uid === currentUid}
				/>
			</div>
			<div className="card p-3 shadow position-relative">
				<TopLeftDetails user={userData} userData={userData} />
				<div className="row align-items-start">
					<div className="col-md-4">
						<UserImage user={userData} readOnly />
						<UserName user={userData} readOnly />
						<WhatsAppLink userData={userData} isMutual={isMutual} />
						<DisplayLanguages userData={userData} />
					</div>
					<div className="col-md-8">
						<UserRecentInterest user={userData} readOnly />
						<DisplayHobbies userData={userData} readOnly />
						<DisplayMusic userData={userData} readOnly />
						<DisplayMovies userData={userData} readOnly />
						<DisplayBooks userData={userData} readOnly />
					</div>
				</div>
			</div>
		</div>
	);
};

export default PublicUserProfile;
